import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FiSearch, FiFilter, FiCalendar, FiBarChart2 } from "react-icons/fi";
import "../../styles/Controls.css";

export default function TaskControls({
  searchQuery,
  setSearchQuery,
  sortType,
  setSortType,
  filterStatus,
  setFilterStatus,
}) {
  const [showSearch, setShowSearch] = useState(false);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  return (
    <div className="controls-wrapper">
      <div className="controls">
        {/* Search Button - Mobile */}
        <button
          className="control-btn search-btn d-md-none"
          onClick={() => setShowSearch(!showSearch)}
        >
          <FiSearch />
        </button>

        {/* Search Input - Desktop */}
        <div className="search-box d-none d-md-flex">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search tasks..."
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>

        {/* Priority Legend */}
        <div className="priority-box">
          <span className="priority high">High</span>
          <span className="priority medium">Medium</span>
          <span className="priority low">Low</span>
        </div>

        {/* Sort Dropdown */}
        <Dropdown>
          <Dropdown.Toggle className="control-btn">
            {sortType === "date" ? <FiCalendar /> : <FiBarChart2 />}
            <span className="btn-text d-none d-sm-inline">
              {sortType === "date" ? "Date" : "Priority"}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setSortType("date")}>
              <FiCalendar className="me-2" /> By Date
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSortType("priority")}>
              <FiBarChart2 className="me-2" /> By Priority
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* Filter Dropdown */}
        <Dropdown>
          <Dropdown.Toggle className="control-btn">
            <FiFilter />
            <span className="btn-text d-none d-sm-inline">
              {filterStatus === "all" ? "All"
                : filterStatus === "open" ? "Open"
                  : filterStatus === "done" ? "Done"
                    : "Archive"}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setFilterStatus("all")}>All Tasks</Dropdown.Item>
            <Dropdown.Item onClick={() => setFilterStatus("open")}>Open</Dropdown.Item>
            <Dropdown.Item onClick={() => setFilterStatus("done")}>Completed</Dropdown.Item>
            <Dropdown.Item onClick={() => setFilterStatus("archived")}>Archived</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Mobile Search - Expands below */}
      {showSearch && (
        <div className="mobile-search d-md-none">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search tasks..."
            value={searchQuery}
            onChange={handleSearch}
            autoFocus
          />
        </div>
      )}
    </div>
  );
}
